import React from 'react';
import ReactAsyncSelect from 'react-select/async';
import { customStyles, DropdownIndicator, SMETheme } from '../Select.jsx';
import useUserOptions from './hooks/useUserOptions.js'

function UserSelect({
  name,
  queryKey,
  value: propsValue,
  label: propsLabel,
  onChange = () => {},
  reset = false,
  isDisabled = false,
  isClearable = false,
  readOnly = false,
  loadingMessage = 'Searching...',
  placeholder,
  valueFormatter,
  excludeUserTypes = [],
}) {
  const {value, setValue, loadOptions} = useUserOptions({queryKey, propsValue, propsLabel, isDisabled, readOnly, reset, excludeUserTypes})

  const handleChange = (v) => {
    setValue(v);
    onChange(v);
  }

  const loadOptionsWithFormat = async (inputValue, valueFormatter) => {
    const options = await loadOptions(inputValue);
    return options.map(option => ({
      ...option,
      value: valueFormatter ? valueFormatter(option.value) : option.value
    }))
  }

  return (
    <ReactAsyncSelect
      name={name}
      value={value?.value ? value : null}
      loadOptions={(inputValue) =>
        loadOptionsWithFormat(inputValue, valueFormatter)
      }
      placeholder={placeholder}
      defaultOptions
      className={`react-select-bootstrap ${isDisabled && "disabled"}  ${readOnly && "readonly"}`}
      loadingMessage={() => loadingMessage}
      styles={customStyles}
      components={{DropdownIndicator: DropdownIndicator}}
      theme={SMETheme}
      onChange={handleChange}
      isDisabled={isDisabled || readOnly}
      isClearable={isClearable}
    />
  )
}

export default UserSelect;
